import Reflux from 'reflux';

const InputTypesActions = Reflux.createActions({
  'list': {asyncResult: true},
  'get': {asyncResult: true},
});

export default InputTypesActions;



// WEBPACK FOOTER //
// ../graylog2-server/graylog2-web-interface/src/actions/inputs/InputTypesActions.js